import { create, StoreApi, UseBoundStore } from 'zustand'

export interface IChipSetStore {
  chipSet: number[]
  currentIndex: number
  tempIndex: number
  computed: {
    currentStake: number
    count: number
    hasNext: boolean
    hasPrev: boolean
  }
}

export let useChipSetStore: UseBoundStore<StoreApi<IChipSetStore>>

export function createShipSetStore(chipSet: number[]) {
  useChipSetStore = create<IChipSetStore>((_, get) => ({
    chipSet,
    currentIndex: 0,
    tempIndex: 0,
    computed: {
      get currentStake() {
        const store = get()
        return store.chipSet.length === 0
          ? 0
          : store.chipSet[store.currentIndex]
      },
      get count() {
        const store = get()
        return store.chipSet.length
      },
      get hasPrev() {
        const store = get()
        return store.currentIndex > 0
      },
      get hasNext() {
        const store = get()
        return store.currentIndex < store.chipSet.length - 1
      },

    },
  }))
}

createShipSetStore([
  0.4,
  0.6,
  1,
  1.6,
  2,
  3,
  4,
  5,
  6,
  7,
  10,
  13,
  15,
  18,
  20,
])
